import { gql, MutationHookOptions, QueryHookOptions, useMutation, useQuery } from '@apollo/client'
import {
  Mutation,
  MutationCreateCustomFieldArgs,
  MutationDeleteCustomFieldArgs,
  MutationUpdateCustomFieldArgs,
  MutationUpdateCustomFieldsOrderArgs,
  Query,
  QueryCustomFieldsArgs,
} from '../gen/models'

export const CustomFieldFragment = gql`
  fragment CustomFieldFragment on CustomField {
    id
    name
    label
    description
    type
    target
    options
    visibility
    editableBy
    required
    customerId
    createdAt
  }
`

export const CUSTOM_FIELDS_QUERY = gql`
  query customFields($filter: CustomFieldFilterInput) {
    customFields(filter: $filter) {
      ...CustomFieldFragment
    }
  }
  ${CustomFieldFragment}
`

export const useCustomFieldsQuery = (
  baseOptions?: QueryHookOptions<Pick<Query, 'customFields'>, QueryCustomFieldsArgs>,
) => useQuery(CUSTOM_FIELDS_QUERY, baseOptions)

const CREATE_CUSTOM_FIELD = gql`
  mutation createCustomField($input: CustomFieldInput!) {
    createCustomField(input: $input) {
      ...CustomFieldFragment
    }
  }
  ${CustomFieldFragment}
`

export function useCreateCustomFieldMutation(
  options?: MutationHookOptions<Pick<Mutation, 'createCustomField'>, MutationCreateCustomFieldArgs>,
) {
  return useMutation<Pick<Mutation, 'createCustomField'>, MutationCreateCustomFieldArgs>(CREATE_CUSTOM_FIELD, options)
}

const UPDATE_CUSTOM_FIELD = gql`
  mutation updateCustomField($id: String!, $input: CustomFieldInput!) {
    updateCustomField(id: $id, input: $input) {
      ...CustomFieldFragment
    }
  }
  ${CustomFieldFragment}
`

export function useUpdateCustomFieldMutation(
  options?: MutationHookOptions<Pick<Mutation, 'updateCustomField'>, MutationUpdateCustomFieldArgs>,
) {
  return useMutation<Pick<Mutation, 'updateCustomField'>, MutationUpdateCustomFieldArgs>(UPDATE_CUSTOM_FIELD, options)
}

const REMOVE_CUSTOM_FIELD = gql`
  mutation deleteCustomField($id: String!) {
    deleteCustomField(id: $id)
  }
`

export function useRemoveCustomFieldMutation(
  options?: MutationHookOptions<Pick<Mutation, 'deleteCustomField'>, MutationDeleteCustomFieldArgs>,
) {
  return useMutation(REMOVE_CUSTOM_FIELD, options)
}

const UPDATE_CUSTOM_FIELDS_ORDER = gql`
  mutation updateCustomFieldsOrder($input: [CustomFieldUpdateOrderInput!]!) {
    updateCustomFieldsOrder(input: $input)
  }
`

export function useUpdateCustomFieldsOrderMutation(
  options?: MutationHookOptions<Pick<Mutation, 'updateCustomFieldsOrder'>, MutationUpdateCustomFieldsOrderArgs>,
) {
  return useMutation<Pick<Mutation, 'updateCustomFieldsOrder'>, MutationUpdateCustomFieldsOrderArgs>(
    UPDATE_CUSTOM_FIELDS_ORDER,
    options,
  )
}
